import { render } from "./PRs.vue?vue&type=template&id=21aa673b"
import script from "./PRs.vue?vue&type=script&lang=js"
export * from "./PRs.vue?vue&type=script&lang=js"

import "./PRs.vue?vue&type=style&index=0&id=21aa673b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pullrequests/PRs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21aa673b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21aa673b', __exports__)) {
    api.reload('21aa673b', __exports__)
  }
  
  module.hot.accept("./PRs.vue?vue&type=template&id=21aa673b", () => {
    api.rerender('21aa673b', render)
  })

}


export default __exports__